const plugin = require('tailwindcss/plugin');
// const defaultTheme = require('tailwindcss/defaultTheme')

/** @type {import('tailwindcss').Config} */
module.exports = {
  important: true,
  // darkMode: 'class',
  safelist: [
    // {
    //   pattern: /.*/,
    // },
    // 'dark',
    {
      pattern: /(text|bg|border)-[a-z]+-[0-9]+/,
      variants: ['hover', 'focus', 'active'],
    },
    // {
    //   pattern: /(p|pt|pb|pr|pl|px|py|m|mt|mb|mr|ml|mx|my)-[0-9]+/,
    //   variants: ['dark', 'child'],
    // },
  ],
  content: [
    './public/index.html',
    './src/**/*.{vue,ts,js}',
  ],
  theme: {
    extend: {

      colors: {
        bronze: {
          DEFAULT: '#BF8970',
          '50': '#F8F2EF',
          '100': '#F1E6E1',
          '200': '#E5CFC5',
          '300': '#D8B8A8',
          '400': '#CCA08C',
          '500': '#BF8970',
          '600': '#AB6A4C',
          '700': '#84523B',
          '800': '#5D3A2A',
          '900': '#362218'
        },
        silver: {
          DEFAULT: '#C0C0C0',
          '50': '#FFFFFF',
          '100': '#FFFFFF',
          '200': '#FDFDFD',
          '300': '#E9E9E9',
          '400': '#D4D4D4',
          '500': '#C0C0C0',
          '600': '#A4A4A4',
          '700': '#888888',
          '800': '#6C6C6C',
          '900': '#505050'
        },
        gold: {
          DEFAULT: '#FFD700',
          '50': '#FFF4B8',
          '100': '#FFF1A3',
          '200': '#FFEA7A',
          '300': '#FFE452',
          '400': '#FFDD29',
          '500': '#e1c000',
          '600': '#8F7800',
          '700': '#574900',
          '800': '#1F1A00',
          '900': '#1F1A00'
        },
      },
      // here's how to extend fonts if needed
      fontFamily: {
        // default: ['Overpass', 'sans-serif'],
      },
      rotate: {
        '270': '270deg',
        '315': '315deg',
      },
    },
  },
  plugins: [
    require('tailwind-children'),
    require('@tailwindcss/aspect-ratio'),
    require('@tailwindcss/line-clamp'),
    require('@tailwindcss/typography'),
    require('@tailwindcss/forms'),
    plugin(function ({addVariant, e, postcss}) {
      addVariant('firefox', ({container, separator}) => {
        const isFirefoxRule = postcss.atRule({
          name: '-moz-document',
          params: 'url-prefix()',
        });
        isFirefoxRule.append(container.nodes);
        container.append(isFirefoxRule);
        isFirefoxRule.walkRules((rule) => {
          rule.selector = `.${e(`firefox${separator}${rule.selector.slice(1)}`)}`;
        });
      });
    }),
  ],
};
